/* import __COLOCATED_TEMPLATE__ from './popup-menu.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
